<template>
  <div class="frame-container">
    <iframe
      height="100%"
      width="100%"
      frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" allowtransparency="yes"
      :src = params
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      params:'',
      serverUrl:'/scada/#/workspace?tUpset='
    }
  },
  methods:{
    EncryUrl(query){
      try {
        query = JSON.stringify(query);
        query = window.encodeURIComponent(query);
        return window.btoa(query); // 编码
      } catch (err) {
        console.log('%c url-encry-error：' + JSON.stringify(err), 'color:red;');
      }
      return "";
    }
  },
  created(){
    let now = Date.parse(new Date());
    let x = {
      uid: this.$store.state.userInfo.id,
      token:this.$store.state.token,
      time_start:now,
      dtid:this.$route.query.dtid,
      guid:this.$route.query.guid,
      cfid:this.$route.query.cfid
    }
    x = this.EncryUrl(x)
    this.params = this.$store.state.updateUrl+x;
  }
}
</script>

<style>

</style>
